import compose from 'recompose/compose'
import withPosition from '../withPosition/withPosition'
import { connect } from 'react-redux'
import { lookupElement } from '../../methods/lookupElement'
import React from 'react'
import withPanoState from '../withPosition/withPanoState'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

const mapStateToProps = (state, { stopId }) => {
    return {
        state,
        isInIframe: state.getIn(['device', 'isInIframe']),
        useResponsiveUI: QueryParamUtils.useResponsiveUI(),
        visitedStop: state.getIn(['interactiveElements', 'meta', 'visited', 'byStop', String(stopId)]),
        enable3D: state.getIn(['interactiveElements', 'enable3D']),
        viewportWidth: state.getIn(['device', 'viewportWidth']),
        viewportHeight: state.getIn(['device', 'viewportHeight']),
    }
}

const stopProps = function(Component) {
    return class extends React.Component {
        shouldComponentUpdate({ visitedStop }) {
            if (this.init) {
                return (
                    (visitedStop != null && this.props.visitedStop == null) ||
                    (!!visitedStop && visitedStop.size !== this.props.visitedStop.size)
                )
            } else {
                this.init = true
                return true
            }
        }
        render() {
            return <Component {...this.props} />
        }
    }
}

const getElement = Component => ({ state, type, ...props }) => {
    const el = lookupElement({ id: props.id, type, state, toJS: true })
    const newProps = {
        ...el,
        ...props,
        state,
    }
    return <Component {...newProps} />
}

export default compose(
    connect(mapStateToProps),
    stopProps,
    getElement,
    withPosition,
    stopProps,
    withPanoState
)
